export const polygonZaps = [
  {
    // QuickSwap
    zapAddress: '0x540A9f99bB730631BF243a34B19fd00BA8CF315C',
    ammRouter: '0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff',
    ammFactory: '0x5757371414417b8C6CAad45bAeF941aBc7d3Ab32',
    ammPairInitHash: '0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f',
  },
  {
    // Cometh
    zapAddress: '0x872c9DCE4B107042933AFD51E8A704631f7EE076',
    ammRouter: '0x93bcDc45f7e62f89a8e901DC4A0E2c6C427D9F25',
    ammFactory: '0x800b052609c355cA8103E06F022aA30647eAd60a',
    ammPairInitHash: '0x499154cad90a3563f914a25c3710ed01b9a43b8471a35ba8a66a056f37638542',
  },
  {
    // Sushi
    zapAddress: '0xf039fe26456901F863c873556f40fb207C6c9C18',
    ammRouter: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506',
    ammFactory: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4',
    ammPairInitHash: '0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303',
  },
  {
    // Wault
    zapAddress: '0x0EA7b115D96C4dF61B3e7d6757f0050F23492929',
    ammRouter: '0x3a1D87f206D12415f5b0A33E786967680AAb4f6d',
    ammFactory: '0xa98ea6356A316b44Bf710D5f9b6b4eA0081409Ef',
    ammPairInitHash: '0x1cdc2246d318ab84d8bc7ae2a3d81c235f3db4e113f4c6fdc1e2211a9291be47',
  },
  {
    // ApeSwap
    zapAddress: '0xaAa3477c6b326e2E416Af7506A30F4519bC9960F',
    ammRouter: '0xC0788A3aD43d79aa53B09c2EaCc313A787d1d607',
    ammFactory: '0xCf083Be4164828f00cAE704EC15a36D711491284',
    ammPairInitHash: '0x511f0f358fe530cda0859ec20becf391718fdf5a329be02f4c95361f3d6a42d8',
  },
  {
    // DYFN
    zapAddress: '0x1A53c6FCa349c23f573CEdd3F8AFE70c02CcEC39',
    ammRouter: '0xA102072A4C07F06EC3B4900FDC4C7B80b6c57429',
    ammFactory: '0xE7Fb3e833eFE5F9c441105EB65Ef8b261266423B',
    ammPairInitHash: '0xf187ed688403aa4f7acfada758d8d53698753b998a3071b06f1b777f4330eaf3',
  },
  {
    // Jetswap
    zapAddress: '0x2302Fff1408eAb81B5912FD9EDA887A9Ab190727',
    ammRouter: '0x5C6EC38fb0e2609672BDf628B1fD605A523E5923',
    ammFactory: '0x668ad0ed2622C62E24f0d5ab6B6Ac1b9D2cD4AC7',
    ammPairInitHash: '0x505c843b83f01afef714149e8b174427d552e1aca4834b4f9b4b525f426ff3c6',
  },
];
